import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import ModuleJustDoYourBest from "./promotion_modules/modules_justDoYourBest"
export default function JDBExclusivePromo() {
  const [activeModal, setActiveModal] = useState("")

  const modalComponents = {
    "JDB Exclusive Promo": ModuleJustDoYourBest,
  }

  const ActiveModal = activeModal ? modalComponents[activeModal] : null

  const data = promotionsData.find(
    (promo) => promo.title === "JDB Exclusive Promo"
  )
  const [isMobile, setIsMobile] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  const handleJDB = () => {
    if (!isLoggedIn) {
      window.location.href = "/promotion"
    } else {
      setActiveModal("JDB Exclusive Promo")
    }
  }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>JDB Exclusive Promo</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion">Promotions</a> / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
              <div className="promotion-tnc-content">
                <div className="promotion-tnc-info">
                  <div
                    className={`promotion-indication-message ${data.promotionMessage.class}`}
                  >
                    {data.promotionMessage.text}
                  </div>
                  <h1>Just Do Your Best, We’ll Handle the Rest!</h1>
                  <h2>Top 25 Players Win EXCLUSIVE Free Spins!</h2>
                  <div className="promotion-tnc-period">
                    <p>
                      <strong>Promo Period: </strong>
                      <span>JULY 01 (12:00 PM) – JULY 31 (11:59 AM), 2025</span>
                    </p>
                  </div>
                  <div className="promotion-tnc-period">
                    <p>
                      <strong>
                        Bi-Weekly Awards: Play More, Spin More - Join the
                        Turnover Race!
                      </strong>
                    </p>
                  </div>
                  <div className="promotion-tnc-mechanic-content">
                    <div className="promotion-tnc-btn-wrapper">
                      {isLoggedIn && data.title === "JDB Exclusive Promo" && (
                        <button onClick={handleJDB}>Leaderboard</button>
                      )}
                    </div>
                    <strong> 👾 How to Join: </strong>
                    <ol>
                      <li>
                        Play any{" "}
                        <strong className="highlight"> JDB Slot Game </strong>{" "}
                        from July 1 (12:00 PM) to July 31 (11:59AM).
                      </li>
                      <li>
                        Accumulate at least{" "}
                        <strong className="highlight">
                          {" "}
                          ₱5,000 in total turnover{" "}
                        </strong>{" "}
                        during each cut-off period.
                      </li>
                      <li>
                        Be one of the{" "}
                        <strong className="highlight"> Top 25 </strong> players
                        with the highest JDB turnover{" "}
                        <strong className="highlight"></strong>
                      </li>
                      <li>
                        <strong className="highlight"> Win FREE SPINS </strong>{" "}
                        awarded{" "}
                        <strong className="highlight"> every two weeks!</strong>
                      </li>
                    </ol>
                    <strong> 📅 Awarding Schedule </strong>
                    <ul>
                      <li>
                        <strong className="highlight"> 1st Cut-off: </strong>{" "}
                        July 1 (12:00 PM) to July 16 (11:59AM).
                      </li>
                      <li>
                        <strong className="highlight">
                          Awarding: July 16 at 2:00 PM (Wednesday)
                        </strong>
                      </li>
                    </ul>{" "}
                    <ul>
                      <li>
                        <strong className="highlight"> 2nd Cut-off: </strong>{" "}
                        July 16 (12:00 PM) to July 31 (11:59 AM).
                      </li>
                      <li>
                        <strong className="highlight">
                          Awarding: July 31 at 2:00 PM (Thursday)
                        </strong>
                      </li>
                    </ul>
                    <strong> Terms and Conditions: </strong>
                    <ol>
                      <li>
                        Free Spins are valid for{" "}
                        <strong className="highlight"> 7 Days </strong> from the
                        credit date.
                      </li>
                      <li>
                        All winnings from Free Spins are withdrawable with{" "}
                        <strong className="highlight">
                          {" "}
                          No Rollover Requirement.{" "}
                        </strong>
                      </li>
                      <li>
                        Free Spins will be credited on one of the qualified JDB
                        games.
                      </li>
                    </ol>
                    <div className="table-wrapper">
                      <table
                        className="promotion-tnc-table"
                        style={{ minWidth: "0" }}
                      >
                        <thead>
                          <tr>
                            <th colSpan={4}> 🏆TOP 25 PRIZES </th>
                          </tr>
                          <tr>
                            <th> Rank Group </th>
                            <th> Free Spins </th>
                            <th> Bet Per Free Spin </th>
                            <th> Qualified Games </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td> 🏆 Top 1</td>
                            <td> 120 </td>
                            <td> ₱25 </td>
                            <td> Blossom of Wealth, Fortune Neko </td>
                          </tr>
                          <tr>
                            <td> 🏆 Top 2 </td>
                            <td> 100 </td>
                            <td> ₱20 </td>
                            <td> Open Sesame Mega, CaiShen Coming </td>
                          </tr>
                          <tr>
                            <td> 🏆 Top 3 </td>
                            <td> 80 </td>
                            <td> ₱15 </td>
                            <td> Marvelous IV, Kong </td>
                          </tr>
                          <tr>
                            <td> ⭐ Ranks 4-10 </td>
                            <td> 60 </td>
                            <td> ₱10 </td>
                            <td> Piggy Bank, Mjolnir </td>
                          </tr>
                          <tr>
                            <td> ⭐ Ranks 11-20 </td>
                            <td> 50 </td>
                            <td> ₱6 </td>
                            <td> Pop Pop Candy, Fruity Bonanza </td>
                          </tr>
                          <tr>
                            <td> ⭐ Ranks 21-25 </td>
                            <td> 40 </td>
                            <td> ₱4 </td>
                            <td> Trump Card, Magic Ace Wild Lock </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="promotion-tnc-cta">
                      <a
                        href="/slots/?provider=JDB"
                        className="promotion-cta-btn"
                        style={{ cursor: "pointer" }}
                      >
                        Play Now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {ActiveModal && <ActiveModal closeModal={() => setActiveModal(null)} />}
    </>
  )
}
